import "antd/es/modal/style";
import _Modal from "antd/es/modal";
import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "trigger", "onVisibleChange", "modalProps", "onFinish", "title", "width"];
import React, { useContext, useState, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import useMergedState from "rc-util/es/hooks/useMergedState";
import omit from 'omit.js';
import { createPortal } from 'react-dom';
import BaseForm from '../../BaseForm';
import { noteOnce } from "rc-util/es/warning";
import ScrollLocker from "rc-util/es/Dom/scrollLocker";

function ModalForm(_ref) {
  var _context$locale, _context$locale$Modal, _context$locale2, _context$locale2$Moda, _rest$submitter, _rest$submitter2, _rest$submitter3;

  var children = _ref.children,
      trigger = _ref.trigger,
      onVisibleChange = _ref.onVisibleChange,
      modalProps = _ref.modalProps,
      onFinish = _ref.onFinish,
      title = _ref.title,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, _excluded);

  var domRef = useRef(null);

  var _useMergedState = useMergedState(!!rest.visible, {
    value: rest.visible,
    onChange: onVisibleChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      visible = _useMergedState2[0],
      setVisible = _useMergedState2[1];

  var context = useContext(_ConfigProvider.ConfigContext);
  var renderDom = useMemo(function () {
    var _context$getPopupCont;

    if (modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer) {
      if (typeof (modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer) === 'function') {
        var _modalProps$getContai;

        return modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$getContai = modalProps.getContainer) === null || _modalProps$getContai === void 0 ? void 0 : _modalProps$getContai.call(modalProps);
      }

      if (typeof (modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer) === 'string') {
        return document.getElementById(modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer);
      }

      return modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer;
    }

    if ((modalProps === null || modalProps === void 0 ? void 0 : modalProps.getContainer) === false) {
      return false;
    }

    return context === null || context === void 0 ? void 0 : (_context$getPopupCont = context.getPopupContainer) === null || _context$getPopupCont === void 0 ? void 0 : _context$getPopupCont.call(context, document.body); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context, modalProps, visible]);

  var _useState = useState(function () {
    if (typeof window === 'undefined') return undefined;
    return new ScrollLocker({
      container: renderDom || document.body
    });
  }),
      _useState2 = _slicedToArray(_useState, 1),
      scrollLocker = _useState2[0];

  noteOnce( // eslint-disable-next-line @typescript-eslint/dot-notation
  !rest['footer'] || !(modalProps === null || modalProps === void 0 ? void 0 : modalProps.footer), 'ModalForm 是一个 ProForm 的特殊布局，如果想自定义按钮，请使用 submit.render 自定义。');
  useEffect(function () {
    if (visible) {
      var _scrollLocker$lock;

      scrollLocker === null || scrollLocker === void 0 ? void 0 : (_scrollLocker$lock = scrollLocker.lock) === null || _scrollLocker$lock === void 0 ? void 0 : _scrollLocker$lock.call(scrollLocker);
    } else {
      var _scrollLocker$unLock;

      scrollLocker === null || scrollLocker === void 0 ? void 0 : (_scrollLocker$unLock = scrollLocker.unLock) === null || _scrollLocker$unLock === void 0 ? void 0 : _scrollLocker$unLock.call(scrollLocker);
    }

    if (visible && rest.visible) {
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(true);
    }

    return function () {
      var _scrollLocker$unLock2;

      if (!visible) scrollLocker === null || scrollLocker === void 0 ? void 0 : (_scrollLocker$unLock2 = scrollLocker.unLock) === null || _scrollLocker$unLock2 === void 0 ? void 0 : _scrollLocker$unLock2.call(scrollLocker);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  useEffect(function () {
    return function () {
      var _scrollLocker$unLock3;

      scrollLocker === null || scrollLocker === void 0 ? void 0 : (_scrollLocker$unLock3 = scrollLocker.unLock) === null || _scrollLocker$unLock3 === void 0 ? void 0 : _scrollLocker$unLock3.call(scrollLocker);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  /** 设置 trigger 的情况下，懒渲染优化性能；使之可以直接配合表格操作等场景使用 */

  var isFirstRender = useRef(!(modalProps === null || modalProps === void 0 ? void 0 : modalProps.forceRender));
  /**
   * IsFirstRender.current 或者 visible 为 true 的时候就渲染 不渲染能会造成一些问题, 比如再次打开值不对了 只有手动配置
   * drawerProps?.destroyOnClose 为 true 的时候才会每次关闭的时候删除 dom
   */

  var shouldRenderFormItems = useMemo(function () {
    if (isFirstRender.current && visible === false) {
      return false;
    }

    if (visible === false && (modalProps === null || modalProps === void 0 ? void 0 : modalProps.destroyOnClose)) {
      return false;
    }

    return true;
  }, [visible, modalProps === null || modalProps === void 0 ? void 0 : modalProps.destroyOnClose]);
  /** 同步 props 和 本地的 ref */

  var formRef = useRef();
  /** 如果 destroyOnClose ，重置一下表单 */

  useEffect(function () {
    if (visible) {
      isFirstRender.current = false;
    }
  }, [modalProps === null || modalProps === void 0 ? void 0 : modalProps.destroyOnClose, visible]);
  useImperativeHandle(rest.formRef, function () {
    return formRef.current;
  });
  var renderSubmitter = rest.submitter === false ? false : _objectSpread(_objectSpread({}, rest.submitter), {}, {
    searchConfig: _objectSpread({
      submitText: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.okText) || ((_context$locale = context.locale) === null || _context$locale === void 0 ? void 0 : (_context$locale$Modal = _context$locale.Modal) === null || _context$locale$Modal === void 0 ? void 0 : _context$locale$Modal.okText) || '确认',
      resetText: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.cancelText) || ((_context$locale2 = context.locale) === null || _context$locale2 === void 0 ? void 0 : (_context$locale2$Moda = _context$locale2.Modal) === null || _context$locale2$Moda === void 0 ? void 0 : _context$locale2$Moda.cancelText) || '取消'
    }, (_rest$submitter = rest.submitter) === null || _rest$submitter === void 0 ? void 0 : _rest$submitter.searchConfig),
    submitButtonProps: _objectSpread({
      type: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.okType) || 'primary'
    }, (_rest$submitter2 = rest.submitter) === null || _rest$submitter2 === void 0 ? void 0 : _rest$submitter2.submitButtonProps),
    resetButtonProps: _objectSpread({
      preventDefault: true,
      onClick: function onClick(e) {
        var _modalProps$onCancel;

        modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$onCancel = modalProps.onCancel) === null || _modalProps$onCancel === void 0 ? void 0 : _modalProps$onCancel.call(modalProps, e);
        setVisible(false);
      }
    }, (_rest$submitter3 = rest.submitter) === null || _rest$submitter3 === void 0 ? void 0 : _rest$submitter3.resetButtonProps)
  });
  var formDom = /*#__PURE__*/React.createElement("div", {
    ref: domRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(BaseForm, _extends({
    formComponentType: "ModalForm",
    layout: "vertical"
  }, omit(rest, ['visible']), {
    formRef: formRef,
    onFinish: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
        var success;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (onFinish) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return onFinish(values);

              case 4:
                success = _context.sent;

                if (success) {
                  setVisible(false);
                  setTimeout(function () {
                    var _formRef$current;

                    if (modalProps === null || modalProps === void 0 ? void 0 : modalProps.destroyOnClose) (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.resetFields();
                  }, 300);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    submitter: renderSubmitter,
    contentRender: function contentRender(item, submitter) {
      return /*#__PURE__*/React.createElement(_Modal, _extends({
        title: title,
        width: width || 800
      }, modalProps, {
        afterClose: function afterClose() {
          var _modalProps$afterClos;

          modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$afterClos = modalProps.afterClose) === null || _modalProps$afterClos === void 0 ? void 0 : _modalProps$afterClos.call(modalProps);
        },
        getContainer: false,
        visible: visible,
        onCancel: function onCancel(e) {
          var _modalProps$onCancel2;

          setVisible(false);
          modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$onCancel2 = modalProps.onCancel) === null || _modalProps$onCancel2 === void 0 ? void 0 : _modalProps$onCancel2.call(modalProps, e);
        },
        footer: submitter === undefined ? null : submitter
      }), shouldRenderFormItems ? item : null);
    }
  }), children));
  /** 这个是为了支持 ssr */

  var portalRenderDom = useMemo(function () {
    if (typeof window === 'undefined') return undefined;
    return renderDom || document.body;
  }, [renderDom]);
  var triggerDom = /*#__PURE__*/React.createElement(React.Fragment, {
    key: "trigger"
  }, trigger && /*#__PURE__*/React.cloneElement(trigger, _objectSpread(_objectSpread({}, trigger.props), {}, {
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var _trigger$props, _trigger$props$onClic;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setVisible(!visible);
                (_trigger$props = trigger.props) === null || _trigger$props === void 0 ? void 0 : (_trigger$props$onClic = _trigger$props.onClick) === null || _trigger$props$onClic === void 0 ? void 0 : _trigger$props$onClic.call(_trigger$props, e);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onClick(_x2) {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  })));
  /** 如果destroyOnClose，关闭的时候接触渲染Form */

  if ((modalProps === null || modalProps === void 0 ? void 0 : modalProps.destroyOnClose) && !visible) return triggerDom;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderDom !== false && portalRenderDom ? /*#__PURE__*/createPortal(formDom, portalRenderDom) : formDom, triggerDom);
}

export default ModalForm;